import React, {MouseEvent} from "react";
import {useServices} from "../../../../hooks/use-services.hook";
import {observer} from "mobx-react";
import styled from "styled-components";
import {CardBox} from "../../../../basic-components/card/card.box";
import {BookingContactFieldsComponent} from "../../contact/components/booking-contact-fields.component";
import {CheckboxComponent} from "../../../../basic-components/checkbox/checkbox.component";
import {AirlineCompanyName} from "../../../../global-constants";
import {NeutralButton} from "../../../../basic-components/buttons/neutral-button";
import {IonIcon} from "@ionic/react";
import {arrowDownOutline} from "ionicons/icons";
import {useContainerMediaQueriesChecks} from "../../../../hooks/use-container-media-queries-checks.hook";

const DescriptionBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: ${props => props.theme.fontSize.h2};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    width: 100%;
    ${props => props.theme.containerMediaQuery.xsAndBelow} {
        flex-direction: column;
        align-items: flex-start;
        justify-content: unset;
        gap: ${props => props.theme.spacing.flexGap12};
    }
    
`

const BookingContactBox = styled(CardBox)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${props => props.theme.spacing.flexGap24};
    padding: calc(2.25 * ${props => props.theme.spacing.cardDefaultPadding});
    ${props => props.theme.containerMediaQuery.smallScreen}  {
        padding: ${props => props.theme.spacing.cardDefaultPadding};
    }
`

const DataPrivacyContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${props => props.theme.colors.mediumShade};
    gap: 4px;
    font-size: ${props => props.theme.fontSize.subtitle2};
    ${props => props.theme.containerMediaQuery.xsAndBelow} {
        flex-direction: column;
    }
`

const DataPrivacyLink = styled.a`
    color: ${props => props.theme.colors.mediumShade};
    font-weight: ${props => props.theme.fontWeight.bold};
    font-size: inherit;
`

const CompleteWithAgentDetailsButtonBox = styled(NeutralButton)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap8};
`

const CompleteWithAgentDetailsButtonComponent: React.FC = observer(() => {
    const services = useServices();
    const containerMediaQuery = useContainerMediaQueriesChecks();

    if(!services.configuration.isAgencyPortal) {
        return null;
    }

    const onClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.preventDefault();
        services.booking.current.contact.copyFromAgentProfile();
    }
    return (
        <CompleteWithAgentDetailsButtonBox onClick={onClick} fullWidth={containerMediaQuery.xsAndBelow} >
            <IonIcon icon={arrowDownOutline}/>
            <span>
                {services.language.translate('Complete with agent details')}
            </span>
        </CompleteWithAgentDetailsButtonBox>
    )
})



export const BookingContactComponent: React.FC = observer(() => {
    const services = useServices();
    const booking = services.booking.current;

    //const isInHeadlessMode = booking.passengers.some(p => p.isPrimaryContact);

    return (
        <BookingContactBox>
            <DescriptionBox>
                <span>
                    {services.language.translate('Contact details')}
                </span>

               <CompleteWithAgentDetailsButtonComponent/>

            </DescriptionBox>
            <BookingContactFieldsComponent/>
            <DataPrivacyContainerBox>
                <CheckboxComponent mode={"md"}
                                   checked={booking.contact.dataPrivacyAccepted} labelPlacement={"end"} onChange={(isChecked) => booking.contact.dataPrivacyAccepted = isChecked}
                                   label={services.language.translationFor('I would like to receive communications from {companyName}.').withParams({
                                       companyName: AirlineCompanyName
                                   })}/>
                <DataPrivacyLink href={services.externalLinks.privacyPolicyLink} target={"_blank"}>
                    {services.language.translate('Data Privacy')}
                </DataPrivacyLink>
            </DataPrivacyContainerBox>

        </BookingContactBox>
    );
});
